import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { PickupDataProvider } from './contexts/PickupDataContext';
import PickupTaskHistory from './components/PickupTaskHistory';
import PickupTaskPlanning from './components/PickupTaskPlanning';

const PickupTaskPage: React.FC = () => {
    const { t } = useTranslation();

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: t('pickup.pickupTask.tabs.history'),
            children: <PickupTaskHistory />
        },
        {
            key: '2',
            label: t('pickup.pickupTask.tabs.planning'),
            children: <PickupTaskPlanning />,
        }
    ];

    return (
            <PickupDataProvider>
                <Tabs defaultActiveKey="1" items={items} destroyInactiveTabPane={true} className="[&_.ant-tabs-tab]:font-bold" />
            </PickupDataProvider>
    );
}

export default PickupTaskPage;